/**
  不会出现在菜单中的基本路由
  wk 2019-11-29
*/

import Main from '../views/Main';

const otherRouters =
{
	path: '/',
	name: 'otherRouters',
	component: Main,
	children:[
		{
			path: '/pileStationDetail',
			name: 'pileStationDetail',
			meta:{
				parent: ['chargeManage','pileStationList'],
				current: ['pileStationList'],
			},
			component: () => import('../views/charging-manage/pile-station/detail.vue')
		},
		{
			path: '/reportDetail',
			name: 'reportDetail',
			meta:{
				parent: ['chargeManage','pileStationList'],
				current: ['pileStationList'],
			},
			component: () => import('../views/charging-manage/pile-station/report-detail.vue')
		},
		{
			path: '/postageDetail',
			name: 'postageDetail',
			meta:{
				parent: ['chargeManage','pileStationList'],
				current: ['pileStationList'],
			},
			component: () => import('../views/charging-manage/pile-station/postage-detail.vue')
		},
		{
			path: '/settlementDetail',
			name: 'settlementDetail',
			meta:{
				parent: ['chargeManage','pileStationList'],
				current: ['pileStationList'],
			},
			component: () => import('../views/charging-manage/pile-station/settlement-detail.vue')
		},
		{
			path: '/tariffDetail',
			name: 'tariffDetail',
			meta: {
				parent: ['chargeManage','pileStationList'],
				current: ['pileStationList'],
				title: '资费策略',
			},
			component: () => import('../views/charging-manage/pile-station/tariff-detail.vue')
		},
		{
			path: '/replenishmentDetail',
			name: 'replenishmentDetail',
			meta: {
				parent: ['chargeManage','pileStationList'],
				current: ['pileStationList'],
				title: '补能策略',
			},
			component: () => import('../views/charging-manage/pile-station/replenishment-detail.vue')
		},
		{
			path: '/feedforwardDetail',
			name: 'feedforwardDetail',
			meta: {
				parent: ['chargeManage','pileStationList'],
				current: ['pileStationList'],
				title: '馈网策略',
			},
			component: () => import('../views/charging-manage/pile-station/feedforward-detail.vue')
		},

		{
			path: '/pileModelDetail',
			name: 'pileModelDetail',
			meta:{
				parent: ['chargeManage','pileModelList'],
				current: ['pileModelList'],
			},
			component: () => import('../views/charging-manage/pile-model/detail.vue')
		},
		// {
		// 	path: '/pileDetailTab/:id',
		// 	name: 'pileDetailTab',
		// 	meta:{
		// 		parent: ['chargeManage','pileList'],
		// 		current: ['pileList'],
		// 	},
		// 	component: () => import('../views/charging-manage/pile/detail.vue')
		// },
		{
			path: "/summaryDetail",
			name: "summaryDetail", // 清分结算 - 结算总表 详情
			meta: {
				parent: ["clearSettlement", "summaryTable"],
				current: ["summaryTable"],
			},
			component: () =>
				import("../views/clear-settlement/summary-table/table-detail.vue"),
		},
		{
			path: "/summaryTableDetail",
			name: "summaryTableDetail", // 清分结算 - 结算总表 - 结算订单详情
			meta: {
				parent: ["clearSettlement", "summaryTable"],
				current: ["summaryTable"],
			},
			component: () =>
				import("../views/clear-settlement/summary-table/order-detail.vue"),
		},
		{
			path: "/clearDetail",
			name: "clearDetail", // 清分账户
			meta: {
				parent: ["clearSettlement", "clearAccount"],
				current: ["clearAccount"],
			},
			component: () =>
				import("../views/clear-settlement/clear-account/clear-detail.vue"),
		},
		{
			path: '/pileDetail',
			name: 'pileDetail',
			meta:{
				parent: ['chargeManage','pileList'],
				current: ['pileList'],
			},
			component: () => import('../views/charging-manage/pile/pile-detail.vue')
		},
		{
			path: '/repairDetail/:id',
			name: 'repairDetail',
			meta:{
				parent: ['chargeManage','pileList'],
				current: ['pileList'],
			},
			component: () => import('../views/charging-manage/pile/repair-detail.vue')
		},
		{
			path: '/repairAddDetail',
			name: 'repairAddDetail',
			meta:{
				parent: ['chargeManage','pileList'],
				current: ['pileList'],
			},
			component: () => import('../views/charging-manage/pile/repair-add-detail.vue')
		},
		{
			path: '/pileReportDetail',
			name: 'pileReportDetail',
			meta:{
				parent: ['chargeManage','pileList'],
				current: ['pileList'],
			},
			component: () => import('../views/charging-manage/pile/report-detail.vue')
		},
		{
			path: '/pileChargeDetail',
			name: 'pileChargeDetail',
			meta:{
				parent: ['chargeManage','pileList'],
				current: ['pileList'],
			},
			component: () => import('../views/charging-manage/pile/charge-detail.vue')
		},
		{
			path: '/repairListDetail',
			name: 'repairListDetail',
			meta:{
				parent: ['chargeManage','pileList'],
				current: ['pileList'],
			},
			component: () => import('../views/charging-manage/pile/repair-list.vue')
		},
		{
			path: '/faultDetail',
			name: 'faultDetail',
			meta:{
				parent: ['chargeManage','pileList'],
				current: ['pileList'],
			},
			component: () => import('../views/charging-manage/pile/fault-detail.vue')
		},
		{
			path: '/custDetail',
			name: 'custDetail',
			meta:{
				parent: ['custManage','custManageList'],
				current: ['custManageList'],
			},
			component: () => import('../views/cust-manage/cust-detail.vue')
		},
		{
			path: '/orderDetail',
			name: 'orderDetail',
			meta:{
				parent: ['orderManage','orderManageList'],
				current: ['orderManageList'],
			},
			component: () => import('../views/order-manage/detail.vue')
		},
		{
			path: '/orderReconciliationDetail',
			name: 'orderReconciliationDetail',
			meta: {
				parent: ['orderReconciliation','orderReconciliationList'],
				current: ['orderReconciliationList'],
			},
			component: () => import('../views/order-reconciliation/detail.vue')
		},
		{
			path: '/dealerDetail',
			name: 'dealerDetail',
			meta:{
				parent: ['dealerManage','dealerManageList'],
				current: ['dealerManageList'],
			},
			component: () => import('../views/dealer-manage/detail.vue')
		},
		{
			path: '/dealerReportDetail',
			name: 'dealerReportDetail',
			meta:{
				parent: ['dealerManage','dealerManageList'],
				current: ['dealerManageList'],
			},
			component: () => import('../views/dealer-manage/report-detail.vue')
		},
		// {
		// 	path: '/accountsReviewDetail',
		// 	name: 'accountsReviewDetail',
		// 	meta:{
		// 		parent: ['financeManage','accountsReviewList'],
		// 		current: ['accountsReviewList'],
		// 	},
		// 	component: () => import('../views/finance-manage/accounts-review/detail.vue')
		// },
		// {
		// 	path: '/financeReviewDetail',
		// 	name: 'financeReviewDetail',
		// 	meta:{
		// 		parent: ['financeManage','financeReviewList'],
		// 		current: ['financeReviewList'],
		// 	},
		// 	component: () => import('../views/finance-manage/finance-review/detail.vue')
		// },
		{
			path: '/serviceRecordDetail',
			name: 'serviceRecordDetail',
			meta:{
				parent: ['serviceRecord','serviceRecordList'],
				current: ['serviceRecordList'],
			},
			component: () => import('../views/service-record/detail.vue')
		},
		{
			path: '/userManageDetail',
			name: 'userManageDetail',
			meta:{
				parent: ['systemManage','userManageList'],
				current: ['userManageDetail'],
			},
			component: () => import('../views/system-manage/user-manage/detail.vue')
		},
		{
			path: '/roleManageDetail',
			name: 'roleManageDetail',
			meta:{
				parent: ['systemManage','roleManageList'],
				current: ['roleManageDetail'],
			},
			component: () => import('../views/system-manage/role-manage/detail.vue')
		},
	]
};

export default otherRouters
